<div class="tile">
  <h5 class="mb-4 font-medium">
    {{ 'instrument-detail.instrument-key-data.headline' | transloco }}
  </h5>
  <div class="d-flex d-lg-block d-xl-flex justify-content-between">
    <div class="text-color-primary">
      {{ 'instrument-detail.instrument-key-data.rows.marketCap' | transloco }}
    </div>
    <div class="font-medium text-right" data-zid="marketcap">
      @if (model?.marketCap) {
        {{ model.marketCap | bigNumbers: '1.2-2' }} {{ model.marketCapSymbol ?? 'EUR' | currencySymbol }}
      } @else {
        <div class="text-color-primary">&mdash;</div>
      }
    </div>
  </div>
  <hr class="less-margin" />
  <div class="d-flex d-lg-block d-xl-flex justify-content-between">
    <div class="text-color-primary">
      {{ 'instrument-detail.instrument-key-data.rows.numberOfShares' | transloco }}
    </div>
    <div class="font-medium text-right">
      @if (model?.numberOfShares) {
        {{ model.numberOfShares | bigNumbers: '1.0-2' }}
      } @else {
        <div class="text-color-primary">&mdash;</div>
      }
    </div>
  </div>
  <hr class="less-margin" />
  <div class="d-flex d-lg-block d-xl-flex justify-content-between">
    <div class="text-color-primary">
      {{ 'instrument-detail.instrument-key-data.rows.earningsPerShare' | transloco }}
    </div>
    <div class="font-medium text-right" data-zid="earningspershare">
      @if (model?.earningsPerShare) {
        {{ model.earningsPerShare | currency: model.earningsPerShareSymbol ?? 'EUR' : 'symbol' : '1.2' }}
      } @else {
        <div class="text-color-primary">&mdash;</div>
      }
    </div>
  </div>
  <hr class="less-margin" />
  <div class="d-flex d-lg-block d-xl-flex justify-content-between">
    <div class="text-color-primary">
      {{ 'instrument-detail.instrument-key-data.rows.freeFloat' | transloco }}
    </div>
    <div class="font-medium text-right">
      @if (model?.freeFloatPct) {
        {{ model.freeFloatPct | number: '1.2-2' }} %
      } @else {
        <div class="text-color-primary">&mdash;</div>
      }
    </div>
  </div>
  <hr class="less-margin" />
  <div class="d-flex d-lg-block d-xl-flex justify-content-between">
    <div class="text-color-primary">
      {{ 'instrument-detail.instrument-key-data.rows.kbv' | transloco }}
    </div>
    <div class="font-medium text-right">
      @if (model?.kbv) {
        {{ model.kbv | number: '1.2-2' }}
      } @else {
        <div class="text-color-primary">&mdash;</div>
      }
    </div>
  </div>
  <hr class="less-margin" />
  <div class="d-flex d-lg-block d-xl-flex justify-content-between">
    <div class="text-color-primary">
      {{ 'instrument-detail.instrument-key-data.rows.kcv' | transloco }}
    </div>
    <div class="font-medium text-right">
      @if (model?.kcv) {
        {{ model.kcv | number: '1.2-2' }}
      } @else {
        <div class="text-color-primary">&mdash;</div>
      }
    </div>
  </div>
  <hr class="less-margin" />
  <div class="d-flex d-lg-block d-xl-flex justify-content-between">
    <div class="text-color-primary">
      {{ 'instrument-detail.instrument-key-data.rows.kgv' | transloco }}
    </div>
    <div class="font-medium text-right">
      @if (model?.kgv) {
        {{ model.kgv | number: '1.2-2' }}
      } @else {
        <div class="text-color-primary">&mdash;</div>
      }
    </div>
  </div>
  <hr class="less-margin" />
  <div class="d-flex d-lg-block d-xl-flex justify-content-between">
    <div class="text-color-primary">
      {{ 'instrument-detail.instrument-key-data.rows.emissionPrice' | transloco }}
    </div>
    <div class="font-medium text-right" data-zid="emissionprice">
      @if (model?.emissionPrice) {
        {{ model.emissionPrice | currency: model.emissionPriceSymbol ?? 'EUR' : 'symbol' : '1.2' }}
      } @else {
        <div class="text-color-primary">&mdash;</div>
      }
    </div>
  </div>
  <hr class="less-margin" />
  <div class="d-flex d-lg-block d-xl-flex justify-content-between">
    <div class="text-color-primary">
      {{ 'instrument-detail.instrument-key-data.rows.vola' | transloco }}
    </div>
    <div class="font-medium text-right">
      @if (model?.vola) {
        {{ model.vola | number: '1.2-2' }}
      } @else {
        <div class="text-color-primary">&mdash;</div>
      }
    </div>
  </div>
</div>
